module.exports = __webpack_public_path__ + "static/espacio_conmpartido.min-3a659cc02c9c7d56a88f1e03efd01467.png";